import './selectOffice';
import './magicForm';
import ComplexLister from './paginator/complex.js';
import EstateLister from './paginator/estate.js';
import ArticleLister from './paginator/article.js';
import './sortirator';
import './filtrator';
import './translator';
import './searcher/estate.js';
import './searcher/complex.js';

document.addEventListener('DOMContentLoaded', function(event) {
	const obComplexLister = new ComplexLister();
	obComplexLister.init();
	const obEstateLister = new EstateLister();
	obEstateLister.init();
	const obArticleLister = new ArticleLister();
	obArticleLister.init();
});
